import React from "react";
import { Layout, Button, Space } from "antd";
import constants from "../constants/Constants";
import { fronturls } from "../constants/FrontendURLs";
import { useNavigate } from "react-router-dom";

const { Footer } = Layout;

const FootNote = () => {
  const naviagte = useNavigate();

  return (
    <Footer className="flex justify-center xl:justify-between flex-wrap !py-2 text-center xl:text-start">
      <div className="ml-5">
        © {new Date().getFullYear()}{" "}
        <Button type="link" className="!p-0 font-bold">
          <a  rel="noreferrer" href={constants.ProedWebLink} target="_blank">
            PRO-ED
          </a>
        </Button>
        , Inc. All rights reserved.
      </div>{" "}
      <Space size={"middle"}>
        <Button
          type="link"
          className="!p-0 font-bold"
          onClick={() => naviagte(fronturls.Policies)}
        >
          <span>{constants.Policies}</span>
        </Button>
      </Space>
    </Footer>
  );
};

export default FootNote;
